<template>
  <div>
    <open-with-option-dialog
        :show="showAttachOptionsDialog"
        @onDismiss="showAttachOptionsDialog=false"
        @onOptionSelected="attachFileInPartnerApp"
    ></open-with-option-dialog>

    <input
      type="file"
      :id="fileAttachButtonId"
      v-on:change="handleAttachedFileFromWeb"
      @disappear="true"
      style="visibility: hidden"
    />
  </div>
</template>

<script>
import env from "@/utils/env";
import ImageProvider from "@/components/providers/ImageProvider";
import EzUtils from "../../utils/EzUtils";
import OpenWithOptionDialog from "@/components/dialogs/OpenWithOptionDialog";
import { Constants } from '../Constants';
import FileCompression from "../../utils/FileCompression";

export default {
  components: {OpenWithOptionDialog},
  name: "FileAttachItem",
  props: {
    attachFileEvent: {
      type: Boolean,
      default: false,
      required: true,
    },

    fileAttachButtonId: {
      type: String,
      required: true,
    },

    fileAttachmentSize: {
      type: Number,
      default: 1,
    },

    allowFromCamera: {
      type: Boolean,
      default: true,
    },

    allowFromGallery: {
      type: Boolean,
      default: true,
    },

    imageActivityType: {
      type: Number,
      required: false,
      default: 0x0
    },

    compressFile: {
      type: Boolean,
      default: true,
      required: false
    },

  },

  data: () => ({
    showAttachOptionsDialog: false
  }),

  methods: {
    attachFiles() {
      this.$emit("resetAttachFileEvent", {});
      if (env.isWebPlatform()) {
        if (window.AndroidJsInterface) {
          //Airtel related changes
          if(this.isSelfieActiviy()){
            this.showAttachOptionsDialog = true;
          }else{
            this.attachFileInPartnerApp("Gallery");
          }
        }else{
          document.getElementById(this.fileAttachButtonId).click();
        }
      } else {
        ImageProvider.selectImage(
          this.allowFromGallery,
          this.allowFromCamera,
          this.fileAttachmentSize
        ).then((result) => {
          if (result.success) {
            this.filesAttached(result.data);
          }
        });
      }
    },

    attachFileInPartnerApp(option) {
      this.showAttachOptionsDialog = false;
      if (window.AndroidJsInterface) {
        window.AndroidJsInterface.clearImage();
        if (EzUtils.areEqualString("Camera", option, true)) {
          window.AndroidJsInterface.openCamera();
        } else {
          window.AndroidJsInterface.openGallery();
        }
        this.originalPoll(this.filesAttached);
      }
    },

    handleAttachedFileFromWeb(event) {
      this.filesAttached(event.target.files);
      document.getElementById(this.fileAttachButtonId).value = "";
    },

    filesAttached(files) {
      //Airtel related changes
      if (window.AndroidJsInterface) {
        const base64 = window.AndroidJsInterface.getImage();
        let file = EzUtils.getFileFromBaseSixtyFour(base64);
        files = [];
        files.push(file);
      }
      if(files && files.length > 0 && files[0]){
        if (this.compressFile && FileCompression.checkIfValidImageFiles(files)) {
          FileCompression.compressMultipleFiles(files).then(compressedFiles => {
            this.$emit("filesAttached", compressedFiles);
          })
        } else {
          this.$emit("filesAttached", files);
        }
      }
    },

    originalPoll(callback) {
      let startTime = new Date();
      function checkCondition() {
        let currentTime = new Date();
        let timeDiff = EzUtils.timeDifferenceInMinute(currentTime,startTime)
        let result = window.AndroidJsInterface.getImage();
        if (!result && timeDiff<2) {
          setTimeout(checkCondition, 500);
        } else {
          callback();
        }
      }
      checkCondition();
    },

    isSelfieActiviy(){
      return this.imageActivityType ? this.imageActivityType === Constants.SELFIE_IMAGE_ACTIVITY : false;
    }
  },

  watch: {
    attachFileEvent() {
      if (this.attachFileEvent) {
        this.attachFiles();
      }
    },
  },
};
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>